import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import { FieldsApiService, UpdateFieldDTO } from 'features/fields';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

import { fieldsQueryKeys } from './query-keys';

const { updateField } = FieldsApiService();

export const useUpdateField = () => {
  const { message } = App.useApp();

  return useMutation(
    (payload: UpdateFieldDTO) => {
      return updateField(payload);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (data, variables) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: fieldsQueryKeys.detail(variables.id),
          }),
        ]);
        message.success(i18n.t('fields.update.successfulUpdate'));
      },
    },
  );
};
